import React from "react"

import trucks from "../../images/trucks.png"
import jane from "../../images/jane2.png"
import kevin from "../../images/kevin2.jpg"
import kristin from "../../images/kristin2.jpg"

import "./about.scss"

const AboutComponent = () => (
  <section className="section about">
    <h1 className="sectionTitle">What is STOP TOXIC HOUSING?</h1>
    <div className="blockWrapper grey">
      <div className="imageBlock">
        <div className="imageWrapper">
          <img className="homeImage" src={trucks} alt="trucks per day on southern california freeways" />
        </div>
        <div className="homeCaptionWrapper rightAligned">
          <h3 className="homeImageCaption">From <i>Los Angeles Times</i></h3>
        </div>
      </div>
    </div>
    <div className="blockWrapper">
      <div className="textBlock">
        <h2>Who We Are</h2>
        <p>Stop  Toxic  Housing members began working in 2018 to address Los Angeles County problems of housing being built either on toxic-waste sites that were not fully cleaned up --- or in near-freeway areas where diesel particles, mainly from trucks, can be 7-25 times higher than in ambient air. The STH goals are to protect community members from toxic-waste sites and from air toxins on freeways, especially the air toxin of diesel particles. STH leaders are all volunteers and operate by consensus. They include health experts, housewives, Information- technology specialists, interior designers, media specialists, executives in nonprofits, scientists, and university professors. </p>
      </div>
    </div>
    <div className="blockWrapper grey">
      <div className="textBlock">
        <h2>Board Members</h2>
        <div className="board-photos">
          <div className="board-member">
            <div className="photo">
              <img src={jane} alt="jane williams"></img>
            </div>
            <h4>Jane Williams</h4>
          </div>
          <div className="board-member">
            <div className="photo">
              <img src={kevin} alt="kevin wheeler"></img>
            </div>
            <h4>Kevin Wheeler</h4>
          </div>
          <div className="board-member">
            <div className="photo">
              <img src={kristin} alt="kristin shrader-frechette"></img>
            </div>
            <h4>Kristin Shrader-Frechette</h4>
          </div>
        </div>
        <p>
          Stop Toxic Housing board members include Dr. Kristin Shrader-Frechette, Kevin Wheeler, and Jane Williams. Kevin and Kristin are Pasadena, California residents, and Jane lives in Rosamund, California.
        </p>
        <p>
          Jane, an internationally known environmental expert, particularly on clean air, was trained in economics at UCLA and is the executive director of California Communities Against Toxics; she does environmental consulting throughout the United States. Kevin has a graduate degree from UCLA and teaches science writing; he is Adjunct Professor in the School of Nursing at Azusa Pacific University and is also a neighborhood realtor. Kristin, author of 18 books and 450+ scientific-journal publications, is an evironmental scientist from University of Notre Dame where, for decades, she has held the O'Neill Family Endowed Professorship; she also does Los Angeles pollution research.
        </p>
      </div>
    </div>

  </section>
)

export default AboutComponent
